// Cataloagele de câmpuri pentru add-form și import wizard, extrase din
// NcrmContacts.vue pentru a respecta politica de dimensiune (modularity.md).
export const COMPANY_ADD_ADVANCED_FIELD_KEYS = [
  "old_reference",
  "legal_name",
  "fiscal_code",
  "vat_number",
  "registration_number",
  "iban",
  "industry",
  "company_size",
  "employees_count",
  "annual_revenue",
  "email_secondary",
  "email_tertiary",
  "email_primary_label",
  "email_secondary_label",
  "email_tertiary_label",
  "phone_secondary",
  "phone_tertiary",
  "phone_primary_label",
  "phone_secondary_label",
  "phone_tertiary_label",
  "website",
  "address_text", "country",
  "linkedin",
  "facebook",
  "instagram",
  "administrator_name",
  "sales_manager_id",
  "tags",
  "notes",
  "owner_user_id",
];
export const PERSON_ADD_ADVANCED_FIELD_KEYS = [
  "position",
  "department",
  "old_reference",
  "email_secondary",
  "email_tertiary",
  "email_primary_label",
  "email_secondary_label",
  "email_tertiary_label",
  "phone_secondary",
  "phone_tertiary",
  "phone_primary_label",
  "phone_secondary_label",
  "phone_tertiary_label",
  "website",
  "address_text", "country",
  "linkedin",
  "facebook",
  "instagram",
  "tags",
  "notes",
  "owner_user_id",
];
export const COMPANY_ADD_FIELD_TRANSLATION_KEYS = {
  old_reference: "ncrm.contacts.details.company.fields.oldReference",
  website: "ncrm.contacts.details.company.fields.website",
  source: "ncrm.contacts.details.company.fields.source",
  address_text: "ncrm.contacts.details.company.fields.address", country: "ncrm.contacts.details.company.fields.country",
  notes: "ncrm.contacts.details.company.fields.notes",
};
export const PERSON_ADD_FIELD_TRANSLATION_KEYS = {
  position: "ncrm.contacts.details.person.fields.position",
  department: "ncrm.contacts.details.person.fields.department",
  old_reference: "ncrm.contacts.details.person.fields.oldReference",
  source: "ncrm.contacts.details.person.fields.source",
  address_text: "ncrm.contacts.details.person.fields.address", country: "ncrm.contacts.details.person.fields.country",
  notes: "ncrm.contacts.details.person.fields.notes",
};
export const COMPANY_IMPORT_MAPPING_FIELD_KEYS = [
  "old_reference",
  "name",
  "legal_name",
  "fiscal_code",
  "vat_number",
  "registration_number",
  "iban",
  "business_category",
  "business_is_active",
  "industry",
  "company_size",
  "employees_count",
  "annual_revenue",
  "website",
  "email_primary",
  "email_secondary",
  "email_tertiary",
  "email_primary_label",
  "email_secondary_label",
  "email_tertiary_label",
  "phone_primary",
  "phone_secondary",
  "phone_tertiary",
  "phone_primary_label",
  "phone_secondary_label",
  "phone_tertiary_label",
  "address_text", "country",
  "linkedin",
  "facebook",
  "instagram",
  "administrator_name",
  "sales_manager_id",
  "source",
  "tags",
  "notes",
];
export const PERSON_IMPORT_MAPPING_FIELD_KEYS = [
  "ncrm_company_id",
  "old_reference",
  "first_name",
  "last_name",
  "position",
  "department",
  "business_is_active",
  "email_primary",
  "email_secondary",
  "email_tertiary",
  "email_primary_label",
  "email_secondary_label",
  "email_tertiary_label",
  "phone_primary",
  "phone_secondary",
  "phone_tertiary",
  "phone_primary_label",
  "phone_secondary_label",
  "phone_tertiary_label",
  "website",
  "linkedin",
  "facebook",
  "instagram",
  "address_text", "country",
  "source",
  "tags",
  "notes",
];
export const IMPORT_WIZARD_FIELD_TRANSLATION_KEYS = {
  ncrm_company_id: "ncrm.importWizard.fields.linkedCompanyId",
  old_reference: "ncrm.importWizard.fields.oldReference",
  name: "ncrm.importWizard.fields.companyName",
  legal_name: "ncrm.importWizard.fields.legalName",
  fiscal_code: "ncrm.importWizard.fields.fiscalCode",
  vat_number: "ncrm.importWizard.fields.vatNumber",
  registration_number: "ncrm.importWizard.fields.registrationNumber",
  iban: "ncrm.importWizard.fields.iban",
  business_category: "ncrm.importWizard.fields.businessCategory",
  business_is_active: "ncrm.contacts.details.businessStatus.fieldLabel",
  industry: "ncrm.importWizard.fields.industry",
  company_size: "ncrm.importWizard.fields.companySize",
  employees_count: "ncrm.importWizard.fields.employeesCount",
  annual_revenue: "ncrm.importWizard.fields.annualRevenue",
  first_name: "ncrm.importWizard.fields.firstName",
  last_name: "ncrm.importWizard.fields.lastName",
  position: "ncrm.importWizard.fields.position",
  department: "ncrm.importWizard.fields.department",
  email_primary: "ncrm.importWizard.fields.emailPrimary",
  email_secondary: "ncrm.importWizard.fields.emailSecondary",
  email_tertiary: "ncrm.importWizard.fields.emailTertiary",
  email_primary_label: "ncrm.importWizard.fields.emailPrimaryLabel",
  email_secondary_label: "ncrm.importWizard.fields.emailSecondaryLabel",
  email_tertiary_label: "ncrm.importWizard.fields.emailTertiaryLabel",
  phone_primary: "ncrm.importWizard.fields.phonePrimary",
  phone_secondary: "ncrm.importWizard.fields.phoneSecondary",
  phone_tertiary: "ncrm.importWizard.fields.phoneTertiary",
  phone_primary_label: "ncrm.importWizard.fields.phonePrimaryLabel",
  phone_secondary_label: "ncrm.importWizard.fields.phoneSecondaryLabel",
  phone_tertiary_label: "ncrm.importWizard.fields.phoneTertiaryLabel",
  website: "ncrm.importWizard.fields.website",
  address_text: "ncrm.importWizard.fields.addressText", country: "ncrm.importWizard.fields.country",
  linkedin: "ncrm.importWizard.fields.linkedin",
  facebook: "ncrm.importWizard.fields.facebook",
  instagram: "ncrm.importWizard.fields.instagram",
  administrator_name: "ncrm.importWizard.fields.administratorName",
  sales_manager_id: "ncrm.importWizard.fields.salesManagerId",
  source: "ncrm.importWizard.fields.source",
  tags: "ncrm.importWizard.fields.tags",
  notes: "ncrm.importWizard.fields.notes",
  content: "ncrm.importWizard.fields.content",
  title: "ncrm.importWizard.fields.title",
  happened_at: "ncrm.importWizard.fields.happenedAt",
  due_at: "ncrm.importWizard.fields.dueAt",
  legacy_source: "ncrm.importWizard.fields.legacySource",
  legacy_author_name: "ncrm.importWizard.fields.legacyAuthorName",
  owner_user_id: "ncrm.importWizard.fields.ownerUserId",
  type_payload: "ncrm.importWizard.fields.typePayload",
  legacy_payload: "ncrm.importWizard.fields.legacyPayload",
};
